module.exports = "/assets/data/0b780e0d33ae901e914ec69cef6fd216-ME15.data.json";